export enum NotificationPriority {
	Low = 'Low',
	High = 'High',
	Critical = 'Critical'
}
